// extracted by mini-css-extract-plugin
export default {"Container":"history_Container__2cGsa"};